import dialogConfig, { AlmeDialogConfig } from "../AlmeDialog/AlmeDialogConfig";
import closeConfig, { AlmeCloseIconConfig } from "../AlmeCloseIcon/AlmeCloseIconConfig";

interface CloseConfig extends AlmeDialogConfig, AlmeCloseIconConfig { }

export interface AlmeCloseConfig {
    close: CloseConfig;
}

/**
 * This is the baseline close config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeCloseConfig = {
    close: {
        ...closeConfig,
        dialog: {
            ...dialogConfig.dialog,
        },

    },
};

export default defaultConfig;